module.exports = __webpack_public_path__ + "static/img/8.6b03470.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/8.png
// module id = Zopi
// module chunks = 0